module.exports = __webpack_public_path__ + "img/g7.839752a5.jpg";